export default __webpack_public_path__ + "static/media/Banner1.e8724294.webp";